import axios from '../axios'
// 查看所有科室
export const all_catrgory = data => {
    return axios({
        url: '/all_catrgory',
        method: 'get',
        params: data
    })
}
export const collection = data => {
    return axios({
        url: '/collection',
        method: 'get',
        params: data
    })
}

//获取热门模型
export const get_hot_detail = data => {
    return axios({
        url: '/get_hot_detail',
        method: 'get',
        params: data
    })
}

//获取热门模型
export const get_notice = data => {
    return axios({
        url: '/get_notice',
        method: 'get',
        params: data
    })
}